import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionHelper } from 'src/app/auth/permission.helper';
import { RequiredPermissions } from 'src/app/models/permission.model';
import { AuthUser } from '../../models/auth-user.model';
import { UserService } from '../../services/user.service';



@Directive({
    selector: '[appPermissionCheck]'
})
export class PermissionCheckDirective {
    private currentUser: AuthUser;
    private permissions: RequiredPermissions;
    private condition = false;

    @Input('appPermissionCheck') set requiredPermissions(requiredPerm: RequiredPermissions) {
      this.permissions = requiredPerm;
      this.updateView();
    }

    @Input() set appPermissionCheckCustomCondition(customCondition: boolean) {
      this.condition = customCondition;
      this.updateView();
    }

    constructor(
      private templateRef: TemplateRef<any>,
      private vcRef: ViewContainerRef,
      private userService: UserService) {
        this.userService.currentUser.subscribe(authUser => {
          this.currentUser = authUser;
          this.updateView();
        });
      }

    private checkPermission() {
      if (this.currentUser) {
        return !this.permissions ||
          PermissionHelper.evaluatePermission(this.permissions, this.currentUser) ||
          !!this.condition;
      }

      return false;
    }

    private updateView() {
      this.vcRef.clear();

      if (this.checkPermission()) {
        this.vcRef.createEmbeddedView(this.templateRef);
      }
    }
}
